/**
 * Updates the recently viewed products in localStorage.
 * Stores objects with { id, handle } to allow direct product lookup without search.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string} productId - The ID of the product to add.
   * @param {string} productHandle - The handle of the product to add.
   */
  static addProduct(productId, productHandle) {
    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((p) => p.id !== productId);
    viewedProducts.unshift({ id: productId, handle: productHandle });
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from localStorage.
   * Handles both old format (string IDs) and new format ({ id, handle } objects).
   * @returns {{ id: string, handle: string | null }[]} The list of viewed products.
   */
  static getProducts() {
    const raw = JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
    return raw
      .map((item) => (typeof item === 'string' ? { id: item, handle: null } : item))
      .filter((item) => item.handle !== null);
  }
}
